import React, { useState } from "react";
import { Svg, ICON } from "./PhoneShell.jsx";

/**
 * SignIn.dc.html: the signed-out / session-ended screen on a phone. Same
 * action as the desktop ErrorState's "Sign in again" (auth.login()), with the
 * same visible outcome for a blocked or failed sign-in.
 */
export default function PhoneSignIn({ onSignIn, firstTime = false }) {
  const [message, setMessage] = useState(null);
  async function handle() {
    setMessage(null);
    try {
      const r = await onSignIn();
      if (r === null) setMessage("Sign-in is already starting. If nothing happens, reload the page.");
      else if (r && r.account) setMessage("You are signed in. Reload the page to continue.");
      else setMessage("Redirecting to Microsoft sign-in...");
    } catch (err) {
      setMessage(`Sign-in could not start (${(err && (err.errorCode || err.message)) || "unknown error"}). Try again.`);
    }
  }
  return (
    <div className="ph-signin" data-testid="phone-signin">
      <span className="ph-neg">NEG</span>
      <div className="ph-signin-body">
        <span style={{ color: "var(--ph-acc)" }}><Svg size={40} stroke={1.8}>{ICON.lock}</Svg></span>
        <h1>{firstTime ? "Sign in to the cockpit" : "Your session has ended"}</h1>
        <p>Sign in with your company account to continue. Nothing you saved is lost.</p>
      </div>
      <div className="ph-signin-actions">
        <button type="button" className="ph-btn pri" onClick={handle}>{firstTime ? "Sign in" : "Sign in again"}</button>
        <span>Opens Microsoft sign-in</span>
        {message ? <span role="alert">{message}</span> : null}
      </div>
    </div>
  );
}
